export const countAnsweredType = (data, statuses) =>
	data.reduce(
		(prev, next) =>
			prev +
			(next.answered_at && statuses.includes(next._call_history.status)
				? 1
				: 0),
		0,
	);
